<template>
  <div class="w-full">
    <orders-list></orders-list>
  </div>
</template>
<script>
import OrdersList from "@/views/components/Orders/OrdersList.vue";
export default {
  components: {
    OrdersList,
  },
};
</script>
